import React from "react";
import {useTranslation} from "react-i18next";
import Header from "../components/header/Header";
import {Footer} from "../components/footer/Footer";

const Summary = ({}) => {

    const {t} = useTranslation();

    return (
        <div>
            <Header/>
            <div className="bg-white py-8 sm:py-16">

                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto max-w-2xl divide-y divide-gray-100 lg:mx-0 lg:max-w-none">
                        <div className="grid grid-cols-1 gap-10 py-16 lg:grid-cols-3">
                            <div>
                                <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900">{t('CONTACT.TITLE')}</h2>
                                <p className="mt-4 text-base/7 text-gray-600">
                                    {t('CONTACT.SUBTITLE')}
                                </p>
                            </div>
                            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-2 lg:gap-8">
                                <div className="rounded-2xl bg-gray-50 p-10">
                                    <h3 className="text-base/7 font-semibold text-gray-900">{t('CONTACT.ORDERS')}</h3>
                                    <dl className="mt-3 space-y-1 text-sm/6 text-gray-600">
                                        <div>
                                            <dt className="sr-only">Email</dt>
                                            <dd>
                                                <a href="mailto:collaborate@example.com"
                                                   className="font-semibold text-indigo-600">
                                                    orders@leafil.com
                                                </a>
                                            </dd>
                                        </div>
                                        <div className="mt-1">
                                            <dt className="sr-only">Phone number</dt>
                                            <dd>+48 883-267-913</dd>
                                        </div>
                                    </dl>
                                </div>
                                <div className="rounded-2xl bg-gray-50 p-10">
                                    <h3 className="text-base/7 font-semibold text-gray-900">{t('CONTACT.QUESTIONS')}</h3>
                                    <dl className="mt-3 space-y-1 text-sm/6 text-gray-600">
                                        <div>
                                            <dt className="sr-only">Email</dt>
                                            <dd>
                                                <a href="mailto:press@example.com"
                                                   className="font-semibold text-indigo-600">
                                                    ask@leafil.com
                                                </a>
                                            </dd>
                                        </div>
                                        <div className="mt-1">
                                            <dt className="sr-only">Phone number</dt>
                                            <dd>+48 883-267-913</dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Summary;